// 상수, 코드 모음.
"use strict";
// import configs from './configs'
// const dicamo = 'https://eastus.common.solumesl.com:8081'
const dicamo = "https://stage00.common.solumesl.com:8081";
// const dicamo = 'http://edgydevice.com:5001'
// const dicamo = configs.LCDUrl
const methods = {
  GET: "get",
  POST: "post",
  PUT: "put",
  PATCH: "patch",
  DELETE: "delete"
};

const codes = {
  prevPathName: "prevPathName",
  activation: {
    ENABLED: "Enabled",
    DISABLED: "Disabled"
  },
  configKeys: {
    whiteListEnable: "whiteListEnable",
    lbsEnabled: "lbsEnabled",
    batteryMode: "batteryMode",
    location: "location",
    updatePageUnlock: "updatePageUnlock",
    lowPowerMode: "lowPowerMode"
  },
  msg: {
    areaSelection: {
      addCountry: "Add Country.",
      addRegion: "Add Region.",
      addCity: "Add City."
    }
  },
  productionTypes: {
    CLOUD: "cloud",
    LOCAL: "local-server",
    SERVER: "server"
  },
  requests: {
    getChatbotSuggestions: {
      method: methods.GET,
      url: "uts/api/v1/genie/default-questions"
    },
    postChatbotQuery: {
      method: methods.POST,
      url: "uts/api/v1/genie/ask"
    },
    // Logout
    logout: {
      method: methods.POST,
      url: "/api/common/logout"
    },
    // Pickcel Refresh Token
    pickcelRefreshToken: {
      method: methods.GET,
      url: "/api/common/pickcel/token/refresh"
    },
    // Refresh Token
    refreshToken: {
      method: methods.POST,
      url: "/api/common/token/refresh"
    },
    // Notification
    getNotification: {
      method: methods.GET,
      url: "/api/common/noti/gateway"
    },
    getPushNoti: {
      method: methods.GET,
      url: "/api/common/notifications"
    },
    getLastNotification: {
      method: methods.GET,
      url: "/api/common/noti/latest"
    },
    // Label Info
    getAlertSetting: {
      method: methods.GET,
      url: "/api/common/config/alertsetting"
    },
    getSummaryAction: {
      method: methods.GET,
      url: "/api/common/summary"
    },
    getProblemAction: {
      method: methods.GET,
      url: "/api/common/summary/problem"
    },
    getProblemDetail: {
      method: methods.GET,
      url: "/api/common/summary/detail"
    },
    unassignLabel: {
      method: methods.POST,
      url: "/api/common/labels/unlink"
    },
    getScheduleList: {
      method: methods.GET,
      url: "/api/common/labels/schedule"
    },
    getLabelHistoryList: {
      method: methods.GET,
      url: "/api/common/labels/history"
    },
    getLabelHistoryErrorLog: {
      method: methods.GET,
      url: "/api/common/labels/operation/file/download"
    },
    getLinkedGatewayList: {
      method: methods.GET,
      url: "/api/common/gateway"
    },
    getLabelsTypeInfo: {
      method: methods.GET,
      url: "/api/common/labels/type/info"
    },
    getLabelTypeSummaryList: {
      method: methods.GET,
      url: "/api/common/labels/model"
    },
    // Offline Gateway Overview
    getOfflineGatewayDetails: {
      method: methods.GET,
      url: "/api/common/gateway/status"
    },
    // Label Events
    getLabelEventData: {
      method: methods.GET,
      url: "/api/common/labels/events"
    },
    getTrasctionalStatusData: {
      method: methods.GET,
      url: "/api/common/labels/transaction"
    },
    getLabelEventDetails: {
      method: methods.GET,
      url: "/api/common/labels/events/detail"
    },
    // Product Info
    getArticles: {
      method: methods.GET,
      url: "/api/common/articles"
    },
    searchArticles: {
      method: methods.GET,
      url: "/api/common/articles"
    },
    addArticle: {
      method: methods.POST,
      url: "/api/common/articles"
    },
    deleteArticle: {
      method: methods.DELETE,
      url: "/api/common/articles"
    },
    // Product Info, Blink LED
    getLedPatterns: {
      method: methods.GET,
      url: "/api/common/functions/led/pattern"
    },
    saveBlinkLed: {
      method: methods.PUT,
      url: "/api/common/articles/led"
    },
    // Product Info, Add Product
    addArticles: {
      method: methods.POST,
      url: "/api/common/articles"
    },
    getArticleDataKeyList: {
      method: methods.GET,
      url: "/api/common/articles/data"
    },
    // Product Info, Product Detail
    updateArticle: {
      method: methods.PUT,
      url: "/api/common/articles"
    },
    assignArticles: {
      method: methods.POST,
      url: "/api/common/labels/link"
    },
    unassignArticles: {
      method: methods.POST,
      url: "/api/common/labels/unlink"
    },
    getAnArticle: {
      method: methods.GET,
      url: "/api/common/config/articleField"
    },
    getSavedArticleList: {
      method: methods.GET,
      url: "/api/common/preview/template/articles"
    },
    // Update Records
    getRecords: {
      method: methods.GET,
      url: "/api/common/articles/history"
    },
    downloadArticlesFileUpdateRecord: {
      method: methods.GET,
      url: "/api/common/articles/file/download"
    },
    // Update Records Labels Link
    getLabelLinkFileRecords: {
      method: methods.GET,
      url: "/api/common/labels/link/file"
    },
    // Update History
    getUpdateHistory: {
      method: methods.GET,
      url: "/api/common/articles/update/history"
    },
    // Update History Detail
    getUpdateHistoryDetail: {
      method: methods.GET,
      url: "/api/common/articles/update/history/detail"
    },
    // Get Article Validation Error Logs
    getErrorLogs: {
      method: methods.GET,
      url: "/api/common/articles/validationerror/logs"
    },
    getLabelErrorLogs: {
      method: methods.GET,
      url: "/api/common/labels/validationerror/logs"
    },
    // Get Article History Details for Batch Details Export
    getBatchDetails: {
      method: methods.GET,
      url: "/api/common/articles/history/detail"
    },
    // Store Info
    getStores: {
      method: methods.GET,
      url: "/api/common/store"
    },
    deleteStores: {
      method: methods.DELETE,
      url: "/api/common/store"
    },
    getTimezones: {
      method: methods.GET,
      url: "/api/common/store/timezone"
    },
    getAreas: {
      method: methods.GET,
      url: "/api/common/area"
    },
    getUserDetails: {
      method: methods.GET,
      url: "/api/common/account/detail"
    },
    // Store Info: Store Setting, Store Add
    getStoreInfo: {
      method: methods.GET,
      url: "/api/common/store/summary"
    },
    getStoreSummaryInfo: {
      method: methods.GET,
      url: "/api/common/store/setting/summary"
    },
    exceedStoresLicense: {
      method: methods.GET,
      url: "/api/common/company/stores/labels/license"
    },
    addStore: {
      method: methods.POST,
      url: "/api/common/store"
    },
    editStore: {
      method: methods.PUT,
      url: "/api/common/store"
    },
    addAreaInformation: {
      method: methods.POST,
      url: "/api/common/area"
    },
    setLbsConfiguration: {
      method: methods.POST,
      url: "/api/common/lbs/config"
    },
    getCloudStores: {
      method: methods.GET,
      url: "/api/common/store"
    },
    // Whitelist
    getFunctionSetting: {
      method: methods.GET,
      url: "/api/common/whiteList/info"
    },
    addWhiteList: {
      method: methods.POST,
      url: "/api/common/whitelist"
    },
    getWhitelist: {
      method: methods.GET,
      url: "/api/common/whitelist"
    },
    getUnassignedWhitelist: {
      method: methods.GET,
      url: "/api/common/whitelist/unassigned"
    },
    deleteWhitelist: {
      method: methods.DELETE,
      url: "/api/common/whitelist"
    },
    // Gateway POST Log Confgi
    updateGatewayLog: {
      method: methods.POST,
      url: "/api/common/gateway/log/export"
    },
    // Gateway Info
    getGateways: {
      method: methods.GET,
      url: "/api/common/gateway"
    },
    // Gateway Status
    getGatewayStatus: {
      method: methods.GET,
      url: "/api/common/gateway/status/summary"
    },
    // unassigned gateway
    getUnassignedGateways: {
      method: methods.GET,
      url: "/api/common/labels/unassigned"
    },
    // assigned gateway label
    getAassignedGatewaysLabel: {
      method: methods.GET,
      url: "/api/common/labels/gateway"
    },
    getGatewayDetail: {
      method: methods.GET,
      url: "/api/common/gateway/detail"
    },
    getGatewayHistoryDetail: {
      method: methods.GET,
      url: "/api/common/gateway/history/detail"
    },
    scanGateway: {
      method: methods.GET,
      url: "/api/common/scangateway"
    },
    addGateway: {
      method: methods.POST,
      url: "/api/common/gateway"
    },
    deleteGateway: {
      method: methods.DELETE,
      url: "/api/common/gateway"
    },
    // Gateway Info Cloud
    getFloatingGateway: {
      method: methods.GET,
      url: "/api/common/gateway/floating"
    },
    addMacIdGateway: {
      method: methods.POST,
      url: "/api/common/gateway/dps/enrollment"
    },
    rebootGateway: {
      method: methods.PATCH,
      url: "/api/common/gateway"
    },
    // Gateway Firmwares
    getGatewayFirmwaresList: {
      method: methods.GET,
      url: "/api/common/otamanager/gateway"
    },
    deleteGatewayFirmwaresList: {
      method: methods.DELETE,
      url: "/api/common/otamanager/gateway"
    },
    editGatewayFirmware: {
      method: methods.PUT,
      url: "/api/common/otamanager/gateway/map/company"
    },
    updateGatewayFirmware: {
      method: methods.POST,
      url: "/api/common/otamanager/gateway"
    },

    downloadGatewayFirmware: {
      method: methods.PUT,
      url: "/api/common/otamanager/gateway"
    },
    // Template Info
    getTemplates: {
      method: methods.GET,
      url: "/api/common/templates"
    },
    editTemplate: {
      method: methods.PUT,
      url: "/api/common/templates"
    },
    searchTemplates: {
      method: methods.GET,
      url: "/api/common/templates/name"
    },
    addTemplate: {
      method: methods.POST,
      url: "/api/common/templates"
    },
    deleteTemplates: {
      method: methods.DELETE,
      url: "/api/common/templates"
    },
    getTemplateHistoryList: {
      method: methods.GET,
      url: "/api/common/templates/history"
    },
    downloadTemplateHistory: {
      method: methods.GET,
      url: "/api/common/templates/download"
    },
    getTemplatesByLabelCode: {
      method: methods.GET,
      url: "/api/common/templates/labelCode"
    },
    getTemplatesType: {
      method: methods.GET,
      url: "/api/common/templates/type"
    },
    getCustomTemplatesType: {
      method: methods.GET,
      url: "/api/common/templates/type/custom"
    },
    addTemplateType: {
      method: methods.POST,
      url: "/api/common/templates/type"
    },
    addCustomTemplateType: {
      method: methods.POST,
      url: "/api/common/templates/type/custom"
    },
    deleteTemplateType: {
      method: methods.DELETE,
      url: "/api/common/templates/type"
    },
    deleteCustomTemplateType: {
      method: methods.DELETE,
      url: "/api/common/templates/type/custom"
    },

    getPreviewList: {
      method: "post",
      url: "/api/common/preview/template"
    },
    getPreviewListForCustomTemplate: {
      method: "post",
      url: "/api/common/preview/template/unassigned"
    },
    getTemplatesTypeByLabelCode: {
      method: methods.GET,
      url: "/api/common/templates/type/labelCode"
    },
    getTemplatesTypeByLabelCodeForUser: {
      method: methods.GET,
      url: "/api/common/templates/type/store"
    },
    // Template Grouping
    getGroups: {
      method: methods.GET,
      url: "/api/common/templates/mapping/group"
    },
    getGroupDetail: {
      method: methods.GET,
      url: "/api/common/templates/mapping/group/detail"
    },
    getTagTypes: {
      method: methods.GET,
      url: "/api/common/templates/data"
    },
    deleteGroups: {
      method: methods.DELETE,
      url: "/api/common/templates/mapping/group"
    },
    // Template Groping: New Template Grouping
    addGroup: {
      method: methods.POST,
      url: "/api/common/templates/mapping/group"
    },
    getTemplatesByTag: {
      method: methods.GET,
      url: "/api/common/templates"
    },
    downloadAllTemplates: {
      method: methods.GET,
      url: "/api/common/templates/download/all"
    },
    downloadAllCustomTemplates: {
      method: methods.GET,
      url: "/api/common/templates/download/all/unassigned"
    },
    // LBS Info: Anchors
    getAnchors: {
      method: methods.GET,
      url: "/api/common/lbs/anchor/config"
    },
    deleteAnchors: {
      method: methods.DELETE,
      url: "/api/common/lbs/anchor/config"
    },
    getStoreSummary: {
      method: methods.GET,
      url: "/api/common/store/summary"
    },
    getResults: {
      method: methods.GET,
      url: "/api/common/lbs/result"
    },
    deleteLbsConfiguration: {
      method: methods.DELETE,
      url: "/api/common/lbs/config"
    },
    // User Info
    getUsers: {
      method: methods.GET,
      url: "/api/common/account"
    },
    editUser: {
      method: methods.PUT,
      url: "/api/common/account"
    },
    deleteUser: {
      method: methods.DELETE,
      url: "/api/common/account"
    },
    getUserAccessLevel: {
      method: methods.GET,
      url: "/api/common/accessLevel"
    },
    // Report Configuration update
    updateEmailConfigList: {
      method: methods.PUT,
      url: "/api/common/account/report/config/multiple"
    },
    getUserDetail: {
      method: methods.GET,
      url: "/api/common/account/detail"
    },
    // User Info Cloud
    getUsersCloud: {
      method: methods.GET,
      url: "/api/common/account/b2c"
    },
    editUserCloud: {
      method: "put",
      url: "/api/common/account/b2c/approval"
    },
    updateUserInfoCloud: {
      method: methods.PUT,
      url: "/api/common/account/info"
    },
    createUserCloud: {
      method: methods.POST,
      url: "/api/common/account/b2c"
    },
    deleteUserCloud: {
      method: methods.DELETE,
      url: "/api/common/account/b2c"
    },

    // Disabling All Reports
    disableAllReports: {
      method: methods.PUT,
      url: "/api/common/config/user/reports"
    },
    // Disabling All Reports End

    resetPasswordUserCloud: {
      method: methods.PATCH,
      url: "/api/common/account/b2c/reset/password"
    },
    getUserMappedStoreCloud: {
      method: methods.GET,
      url: "/api/common/store"
    },
    // User Info: My Info
    getUser: {
      method: methods.GET,
      url: "/api/common/account/detail"
    },
    getDashboardLogo: {
      method: methods.GET,
      url: "/api/common/config/logo"
    },
    updateDashboardLogo: {
      method: methods.POST,
      url: "/api/common/config/logo"
    },
    deleteCustomDashBoardLogo: {
      method: methods.DELETE,
      url: "/api/common/config/logo"
    },
    updateUserInfo: {
      method: methods.PUT,
      url: "/api/common/account"
    },
    updatePassword: {
      method: methods.PUT,
      url: "/api/common/account/password"
    },
    getCompanyList: {
      method: methods.GET,
      url: "/api/common/company"
    },
    changePassword: {
      method: methods.PATCH,
      url: "/api/common/account/b2c/change/password"
    },
    // REPORT CONFIGURATION
    getMyAccountReport: {
      method: methods.GET,
      url: "/api/common/account/report/config"
    },
    updateMyAccountReport: {
      method: methods.PUT,
      url: "/api/common/account/report/config"
    },
    // SoluM Admin
    getDatabaseServer: {
      method: methods.GET,
      url: "/api/common/database/server"
    },
    deleteDatabaseServer: {
      method: methods.DELETE,
      url: "/api/common/database/server"
    },
    postDatabaseServer: {
      method: methods.POST,
      url: "/api/common/database/server"
    },
    getCustomerList: {
      method: methods.GET,
      url: "/api/common/company/details"
    },
    getCustomersHistory: {
      method: methods.GET,
      url: "/api/common/company/update/history"
    },
    updateCustomerInfo: {
      method: methods.PUT,
      url: "/api/common/company"
    },
    updateCustomerPackage: {
      method: methods.PUT,
      url: "/api/common/company/packages"
    },
    updatePickcelStorage: {
      method: methods.PUT,
      url: "/api/common/lcd/pickcel/storage"
    },
    updateCustomerReports: {
      method: methods.PUT,
      url: "/api/common/company/reportdetails"
    },
    updateCustomerUsers: {
      method: methods.PUT,
      url: "/api/common/company/userlimit"
    },
    getDatabaeInfo: {
      method: methods.GET,
      url: "/api/common/database/server"
    },
    postCustomer: {
      method: methods.POST,
      url: "/api/common/company"
    },
    deleteCustomer: {
      method: methods.DELETE,
      url: "/api/common/company"
    },
    getPackageList: {
      method: methods.GET,
      url: "/api/common/packages"
    },
    getCustFunction: {
      method: methods.GET,
      url: "/api/common/config/function"
    },
    convertOldTemplates: {
      method: methods.GET,
      url: "/api/common/templates/types/convert/old/templates"
    },
    postCustFunction: {
      method: methods.POST,
      url: "/api/common/config/function"
    },
    updateCustomerDbinfo: {
      method: methods.PUT,
      url: "/api/common/company/update/database"
    },
    getIncomingRequets: {
      method: methods.GET,
      url: "/api/common/incoming/requests"
    },
    getSIPartnersUser: {
      method: methods.GET,
      url: "/api/common/company/sip/accounts"
    },
    getSIPUsers: {
      method: methods.GET,
      url: "/api/common/sip/users"
    },
    // Open Source Library List Api's
    getOpenSourceLibraryList: {
      method: methods.GET,
      url: "/api/common/about/deployment/opensource/library"
    },
    postOpenSourceLibraryList: {
      method: methods.POST,
      url: "/api/common/about/deployment/opensource/library"
    },
    putOpenSourceLibraryList: {
      method: methods.PUT,
      url: "/api/common/about/deployment/opensource/library"
    },
    deleteOpenSourceLibraryList: {
      method: methods.DELETE,
      url: "/api/common/about/deployment/opensource/library"
    },

    // SIP Master api's
    getSIPartnersMaster: {
      method: methods.GET,
      url: "/api/common/sip"
    },
    postSIPartnersMaster: {
      method: methods.POST,
      url: "/api/common/sip"
    },
    editSIPartnersMaster: {
      method: methods.PUT,
      url: "/api/common/sip"
    },
    deleteSIPMasterListList: {
      method: methods.DELETE,
      url: "/api/common/sip"
    },
    mapSIPartners: {
      method: methods.POST,
      url: "/api/common/company/sip/mapping"
    },
    getSipMappingInfo: {
      method: methods.GET,
      url: "/api/common/company/sip/mapping"
    },
    getSuperAdmins: {
      method: methods.GET,
      url: "/api/common/company/superadmin/accounts"
    },
    getCustomerPackages: {
      method: methods.GET,
      url: "/api/common/company/packages"
    },
    getExistingScheduleData: {
      method: methods.GET,
      url: "/api/common/templates/mapping/schedule/info"
    },
    getCustomerExpInfo: {
      method: methods.GET,
      url: "/api/common/company/expiry/info"
    },
    mapMultipleSIPartners: {
      method: methods.POST,
      url: "/api/common/company/sip/mapping/multiple"
    },
    // System Config: App Config
    getProductIdExtractionList: {
      method: methods.GET,
      url: "/api/common/config/productIdExtraction"
    },
    putProductIdExtractionList: {
      method: methods.PUT,
      url: "/api/common/config/productIdExtraction"
    },
    getAddInfo: {
      method: methods.GET,
      url: "/api/common/config/addInfo"
    },
    putAddInfo: {
      method: methods.PUT,
      url: "/api/common/config/addInfo"
    },
    getEditableProductInfo: {
      method: methods.GET,
      url: "/api/common/config/editableProductInfo"
    },
    putEditableProductInfo: {
      method: methods.PUT,
      url: "/api/common/config/editableProductInfo"
    },
    uploadMultipartFile: {
      method: methods.POST,
      url: "/api/common/articles/upload/multipart"
    },
    uploadZipMultipartFile: {
      method: methods.POST,
      url: "/api/common/articles/upload/zip/multipart"
    },
    getLBSInfo: {
      method: methods.GET,
      url: "/api/common/config/lbs/location"
    },
    putLBSInfo: {
      method: methods.PUT,
      url: "/api/common/config/lbs/location"
    },
    // Keyboard Configuration
    getKeyboardInfo: {
      method: methods.GET,
      url: "/api/common/config/pda/keyboard"
    },
    postKeyboardConfigInfo: {
      method: methods.POST,
      url: "/api/common/config/pda/keyboard"
    },
    getAssignBarcode: {
      method: methods.GET,
      url: "/api/common/config/assignbarcode"
    },
    postAssignBarcode: {
      method: methods.POST,
      url: "/api/common/config/assignbarcode/list"
    },
    // Label, Article operations
    postLabelOperations: {
      method: methods.POST,
      url: "/api/common/labels/schedule"
    },
    postLabelOperationsByArticle: {
      method: methods.POST,
      url: "/api/common/labels/schedule/article"
    },
    getDisplayPage: {
      method: methods.GET,
      url: "/api/common/config/max/images"
    },
    postAssignData: {
      method: methods.POST,
      url: "/api/common/labels/link"
    },
    // Dicamo Overview
    getOverviewData: {
      method: methods.POST,
      url: dicamo + "/SolumOverviewA"
    },
    // Dicamo Media
    getMedia: {
      method: methods.POST,
      url: dicamo + "/index.php/SolumMediaA/get"
    },
    getMediaItem: {
      method: methods.POST,
      url: dicamo + "/index.php/SolumMediaA/get"
    },
    addMedia: {
      method: methods.POST,
      url: dicamo + "/index.php/SolumMediaA/post"
    },
    editMediaItem: {
      method: methods.POST,
      url: dicamo + "/index.php/SolumMediaA/put"
    },
    deleteMediaItem: {
      method: methods.POST,
      url: dicamo + "/index.php/SolumMediaA/delete"
    },
    getCategory: {
      method: methods.POST,
      url: dicamo + "/index.php/SolumMediaA/get"
    },
    // Dicamo Playlist
    getPlaylist: {
      method: methods.POST,
      url: dicamo + "/index.php/SolumPlaylistSetA/get"
    },
    postPlaylist: {
      method: methods.POST,
      url: dicamo + "/index.php/SolumPlaylistSetA/post"
    },
    putPlaylist: {
      method: methods.POST,
      url: dicamo + "/index.php/SolumPlaylistSetA/put"
    },
    deletePlaylist: {
      method: methods.POST,
      url: dicamo + "/index.php/SolumPlaylistSetA/delete"
    },
    // Dicamo LCD List
    getLcdList: {
      method: methods.POST,
      url: dicamo + "/SolumLCDA/get/list"
    },
    getLcdTemplateAndProduct: {
      method: methods.POST,
      url: dicamo + "/SolumTemplateA/get"
    },
    postLcdList: {
      method: methods.POST,
      url: dicamo + "/SolumLCDA/post"
    },
    putLcdList: {
      method: methods.POST,
      url: dicamo + "/SolumLCDA/put"
    },
    deleteLcdList: {
      method: methods.POST,
      url: dicamo + "/SolumLCDA/delete"
    },
    getScheduleLMappingist: {
      method: methods.POST,
      url: dicamo + "/SolumLCDA/get"
    },
    postScheduleMappingList: {
      method: methods.POST,
      url: dicamo + "/SolumLCDA/put"
    },
    getTemplateList: {
      method: methods.POST,
      url: dicamo + "/index.php/SolumTemplateA/get"
    },
    deleteTemplateList: {
      method: methods.POST,
      url: dicamo + "/index.php/SolumTemplateA/delete"
    },
    postTemplateList: {
      method: methods.POST,
      url: dicamo + "/index.php/SolumTemplateA/post"
    },
    putTemplateList: {
      method: methods.POST,
      url: dicamo + "/index.php/SolumTemplateA/put"
    },
    getAssignTemplateList: {
      method: methods.GET,
      url: dicamo + "/SolumA/Template"
    },
    setTemplatePreview: {
      method: methods.POST,
      url: dicamo + "/SolumTemplateA/put"
    },
    getTemplateExport: {
      method: methods.POST,
      url: dicamo + "/SolumTemplateA/get"
    },
    setTemplateImport: {
      method: methods.POST,
      url: dicamo + "/SolumTemplateA/put"
    },
    assignLcd: {
      method: methods.POST,
      url: dicamo + "/SolumA/Stripe/Post"
    },
    thumbnail: {
      url: dicamo + "/assets/thumbnail/"
    },
    labelThumbnail: {
      url: dicamo + "/assets/SolumMedia/Label/"
    },
    getpdaButtons: {
      method: methods.GET,
      url: "/api/common/config/pda/buttons"
    },
    postpdaButtons: {
      method: methods.POST,
      url: "/api/common/config/pda/buttons"
    },
    getButtonInfo: {
      method: methods.GET,
      url: "/api/common/config/button/properties"
    },
    putButtonInfo: {
      method: methods.PUT,
      url: "/api/common/config/button/properties"
    },
    getLabelTemplateButtonInfo: {
      method: methods.GET,
      url: "/api/common/config/button/properties/label"
    },
    getButtonConfigId: {
      method: methods.GET,
      url: "/api/common/functions/labels/button/config"
    },
    getLCDQuickPlayList: {
      method: methods.GET,
      url: "/api/common/lcd/pickcel/quickplay/video"
    },
    deleteLCDQuickPlay: {
      method: methods.DELETE,
      url: "/api/common/lcd/pickcel/quickplay/video"
    },
    // language  Setting
    getLanguage: {
      method: methods.GET,
      url: "/api/common/config/languageList"
    },
    setLanguage: {
      method: methods.POST,
      url: "/api/common/config/languageList"
    },
    getLanguageContent: {
      method: methods.GET,
      url: "/api/common/config/languageContent"
    },
    uploadLanguageContent: {
      method: methods.POST,
      url: "/api/common/config/languageContent"
    },
    deleteLanguage: {
      method: methods.DELETE,
      url: "/api/common/config/languageList"
    },
    resetLanguage: {
      method: methods.POST,
      url: "/api/common/config/languageContent/reset"
    },
    getAuditLog: {
      method: methods.GET,
      url: "/api/common/audit/log"
    },
    auditLogDetails: {
      method: methods.GET,
      url: "/api/common/audit/log/details"
    },
    getOutOfStock: {
      method: methods.GET,
      url: "/api/common/outofstock"
    },
    getRestockList: {
      method: methods.GET,
      url: "/api/common/account/mapping/store"
    },
    getOutOfStockNoti: {
      method: methods.POST,
      url: "/api/common/outofstock"
    },

    getWastePrevention: {
      method: methods.GET,
      url: "/api/common/wp"
    },
    getScheduleDetailsRule: {
      method: methods.GET,
      url: "/api/common/wp/rule"
    },
    getWpProductExpiry: {
      method: methods.GET,
      url: "/api/common/wp/product/expiry"
    },
    addWastePrevention: {
      method: methods.POST,
      url: "/api/common/wp"
    },
    editWastePrevention: {
      method: methods.PUT,
      url: "/api/common/wp"
    },
    setWastePreventionRule: {
      method: methods.POST,
      url: "/api/common/wp/rule"
    },
    deleteWastePrevention: {
      method: methods.DELETE,
      url: "/api/common/wp"
    },
    getRuleSummary: {
      method: methods.GET,
      url: "/api/common/wp/rule/summary"
    },
    getLabelMaxImages: {
      method: methods.GET,
      url: "/api/common/config/max/images"
    },
    pushImageToLabel: {
      method: methods.POST,
      url: "/api/common/labels/image"
    },
    getGatewayDebugInfo: {
      method: methods.GET,
      url: "/api/common/gateway/debug/info"
    },
    getAuditLogSummary: {
      method: methods.GET,
      url: "/api/common/audit/log/summary"
    },
    getDeploymentInfo: {
      method: methods.GET,
      url: "/api/common/about/deployment/info"
    },
    getAksNodeInfo: {
      method: methods.GET,
      url: "/api/common/about/deployment/node/info"
    },
    getReleaseNotes: {
      method: methods.GET,
      url: "/api/common/about/deployment/release/history"
    },
    getNextReleaseNotes: {
      method: methods.GET,
      url: "/api/common/about/deployment/next/release/info"
    },
    getProductPositionConfgList: {
      method: methods.GET,
      url: "/api/common/article/position/keys"
    },
    postProductPositionConfgList: {
      method: methods.POST,
      url: "/api/common/article/position/keys"
    },
    getShelfIdConfig: {
      method: methods.GET,
      url: "/api/common/article/position/shelf/mapping"
    },
    postShelfIdConfig: {
      method: methods.POST,
      url: "/api/common/article/position/shelf/mapping"
    },
    getStoreScheduleList: {
      method: methods.GET,
      url: "/api/common/article/position/store/schedule"
    },
    postStoreSchedule: {
      method: methods.POST,
      url: "/api/common/article/position/store/schedule"
    },
    putStoreSchedule: {
      method: methods.PUT,
      url: "/api/common/article/position/store/schedule"
    },
    deleteStoreSchedule: {
      method: methods.DELETE,
      url: "/api/common/article/position/store/schedule"
    },
    getAllPodLogs: {
      method: methods.GET,
      url: "/api/common/about/deployment/pod/logs/all"
    },
    getPodLogs: {
      method: methods.GET,
      url: "/api/common/about/deployment/pod/logs"
    },
    updateTemplateArea: {
      method: methods.PUT,
      url: "/api/common/templates/type/area"
    },
    updateCustomTemplateCategory: {
      method: methods.PUT,
      url: "/api/common/templates/type/custom/category"
    },
    getTemplateArea: {
      method: methods.GET,
      url: "/api/common/templates/type/area"
    },
    getCustomTemplateCategory: {
      method: methods.GET,
      url: "/api/common/templates/type/custom/category"
    },
    getTemplateHistory: {
      method: methods.GET,
      url: "/api/common/templates/history"
    },
    downloadTemplate: {
      method: methods.GET,
      url: "/api/common/templates/download"
    },
    deleteCustomTemplateCategory: {
      method: methods.DELETE,
      url: "/api/common/templates/type/custom/category"
    },
    deleteTemplateTypeArea: {
      method: methods.DELETE,
      url: "/api/common/templates/type/area"
    },
    getSystemData: {
      method: methods.GET,
      url: "/api/common/health/monitor/system/info"
    },
    getSystemDataHistory: {
      method: methods.GET,
      url: "/api/common/health/monitor/system/info/history"
    },
    // Get any User Details By Email
    gotoUserDetails: {
      method: methods.GET,
      url: "/api/common/account/b2c/details"
    },
    getAnonymousUserList: {
      method: methods.GET,
      url: "/api/common/account/b2c/anonymous"
    },
    deleteAnonymousUser: {
      method: methods.DELETE,
      url: "/api/common/account/b2c/anonymous"
    },
    getSquarePosToken: {
      method: methods.GET,
      url: "/api/common/squarepos/token"
    },
    getIntegrationStatus: {
      method: methods.GET,
      url: "/api/common/squarepos/integration/status"
    },
    getCatalogFetchStatus: {
      method: methods.GET,
      url: "/api/common/squarepos/catalog/fetch/status"
    },
    addSquarePosCustomer: {
      method: methods.PUT,
      url: "/api/common/squarepos/customer"
    },
    deleteSquarePosCustomer: {
      method: methods.DELETE,
      url: "/api/common/squarepos/customer"
    },
    squarePosFullFlesh: {
      method: methods.POST,
      url: "/api/common/squarepos/catalog/full/flesh"
    },
    // Heartland POS
    getHeartlandPosToken: {
      method: methods.POST,
      url: "/api/common/heartlandpos/token"
    },
    getHeartlandIntegrationStatus: {
      method: methods.GET,
      url: "/api/common/heartlandpos/integration/status"
    },
    heartlandPosFullFlesh: {
      method: methods.POST,
      url: "/api/common/heartlandpos/catalog/full/flesh"
    },
    getHeatlandStoreMapping: {
      method: methods.GET,
      url: "/api/common/heartlandpos/store/mapping"
    },
    postHeatlandStoreMapping: {
      method: methods.POST,
      url: "/api/common/heartlandpos/store/mapping"
    },
    heatlandLocationSync: {
      method: methods.GET,
      url: "/api/common/heartlandpos/sync/locations"
    },
    deleteHeartlandPosCustomerMapping: {
      method: methods.DELETE,
      url: "/api/common/heartlandpos/customer"
    },
    getHeatlandCatalogFetchStatus: {
      method: methods.GET,
      url: "/api/common/heartlandpos/catalog/fetch/status"
    },
    getHeatlandPosAuditLogs: {
      method: methods.GET,
      url: "/api/common/heartlandpos/audit/log"
    },
    // Yellow Dog POS
    getYellowDogStoreList: {
      method: methods.GET,
      url: "/api/common/yellowdogpos/get/stores"
    },
    getYellowDogStoreMapping: {
      method: methods.GET,
      url: "/api/common/yellowdogpos/store-mapping"
    },
    postYellowDogStoreMapping: {
      method: methods.POST,
      url: "/api/common/yellowdogpos/store-mapping"
    },
    yellowDogIntegrationStatus: {
      method: methods.GET,
      url: "/api/common/yellowdogpos/customer/integration-status"
    },
    deleteYellowDogPosCustomerMapping: {
      method: methods.DELETE,
      url: "/api/common/yellowdogpos/customer/mapping"
    },
    registerYellowDogPosCustomerMapping: {
      method: methods.POST,
      url: "/api/common/yellowdogpos/customer/mapping"
    },
    getYellowDogCatalogFetchStatus: {
      method: methods.GET,
      url: "/api/common/yellowdogpos/catalog/fetch/status"
    },
    postYellowDogCatalogFetchStatus: {
      method: methods.POST,
      url: "/api/common/yellowdogpos/catalog/full/fetch"
    },
    getYellowDogPosAuditLogs: {
      method: methods.GET,
      url: "/api/common/yellowdogpos/audit/log"
    },
    // USER MANUALS API'S
    userManualDataList: {
      method: methods.GET,
      url: "/api/common/about/deployment/user/manuals"
    },
    uploadUserManual: {
      method: methods.PUT,
      url: "/api/common/about/deployment/user/manuals"
    },
    getLabelLinkedArticle: {
      method: methods.GET,
      url: "/api/common/labels/article"
    },
    getScheduleArticle: {
      method: methods.GET,
      url: "/api/common/articles/schedule"
    },
    postScheduleArticle: {
      method: methods.POST,
      url: "/api/common/articles/schedule"
    },
    editScheduleArticle: {
      method: methods.PUT,
      url: "/api/common/articles/schedule"
    },
    deleteLabels: {
      method: methods.DELETE,
      url: "/api/common/labels"
    },
    productScheduledInfo: {
      method: methods.GET,
      url: "/ps/api/v1/article/schedule"
    },
    getScheduleDetails: {
      method: methods.GET,
      url: "/ps/api/v1/article/schedule/data"
    },
    getBachIdListInfo: {
      method: methods.GET,
      url: "/ps/api/v1/article/schedule/batch-ids"
    },
    getArticleScheduleBachIdListInfo: {
      method: methods.GET,
      url: "/ps/api/v1/article/schedule/article-schedule-batch-ids"
    },
    uploadJsonFile: {
      method: methods.POST,
      url: "/ps/api/v1/article/schedule/upload/file"
    },
    getLabels: {
      method: methods.GET,
      url: "/api/common/labels"
    },

    getunAssignedLabels: {
      method: methods.GET,
      url: "/api/common/labels/unassigned/status"
    },
    addFloorPlan: {
      method: methods.POST,
      url: "/api/common/gateway/floorplan"
    },
    getFloorPlan: {
      method: methods.GET,
      url: "/api/common/gateway/floorplan"
    },
    deleteScheduleProduct: {
      method: methods.DELETE,
      url: "/api/common/articles/schedule"
    },
    deleteLabelScheduleProduct: {
      method: methods.DELETE,
      url: "/api/common/labels/schedule"
    },
    deleteLabelScheduleRepeat: {
      method: methods.DELETE,
      url: "/api/common/labels/repeatschedule"
    },
    // Azur-Metrics
    getIoTHubMetrics: {
      method: methods.GET,
      url: "/api/common/azure/metrics/getIoTHubMetrics"
    },
    getStorageMetrics: {
      method: methods.GET,
      url: "/api/common/azure/metrics/getStorageMetrics"
    },
    azureMetricsApplicationGateway: {
      method: methods.GET,
      url: "/api/common/azure/metrics/getApplicationGatewayMetrics"
    },
    azureMetricsEventHub: {
      method: methods.GET,
      url: "/api/common/azure/metrics/getEventHubMetrics"
    },
    azureMetricsHttpRequest: {
      method: methods.GET,
      url: "/api/common/azure/metrics/getApplicationGatewayMetrics/httpStatus"
    },
    getUploadedFileFormat: {
      method: methods.GET,
      url: "/api/common/articles/upload/format"
    },
    getStatusofStatistics: {
      method: methods.GET,
      url: "/api/common/statistics/services/getstatus"
    },
    createStatisticsProgram: {
      method: methods.POST,
      url: "/api/common/statistics/services/createprogram"
    },
    setStartStatisticsProgram: {
      method: methods.GET,
      url: "/api/common/statistics/services/startprogram"
    },
    setOffStatisticsProgram: {
      method: methods.DELETE,
      url: "/api/common/statistics/services/stopprogram"
    },
    resendLabel: {
      method: methods.PUT,
      url: "/api/common/labels/resend/timeout"
    },
    resendAllLabel: {
      method: methods.PUT,
      url: "/api/common/labels/resend/timeout/all"
    },
    getStoreMapping: {
      method: methods.GET,
      url: "/api/common/squarepos/store/mapping"
    },
    postStoreMapping: {
      method: methods.POST,
      url: "/api/common/squarepos/store/mapping"
    },
    getSquarePOSCustomAttribute: {
      method: methods.GET,
      url: "/api/common/squarepos/customattributes"
    },
    postSquarePOSCustomAttribute: {
      method: methods.POST,
      url: "/api/common/squarepos/customattributes"
    },
    // Customer Summary
    getCustomerSummary: {
      method: methods.GET,
      url: "/api/common/reports/img/generation/summary"
    },
    replicateArticle: {
      method: methods.POST,
      url: "/api/common/articles/store/replicate"
    },
    downloadArticleData: {
      method: methods.GET,
      url: "/api/common/articles/download"
    },
    getLabelAliveHistory: {
      method: methods.GET,
      url: "/api/common/labels/alive/history"
    },
    getLabelStatusHistory: {
      method: methods.GET,
      url: "/api/common/labels/status/history"
    },
    // FOR EXPORT LABELS STATUS HISTORY DETAILS.
    getReportHistory: {
      method: methods.GET,
      url: "/api/common/labels/status/history"
    },
    updateMappingInfo: {
      method: methods.POST,
      url: "/api/common/articles/mappinginfo"
    },
    getEanMappingHistory: {
      method: methods.GET,
      url: "/api/articles/mappinginfo/history"
    },
    postMappingInfoUpload : {
      method: methods.POST,
      url: "/api/common/articles/mappinginfo/upload"
    },
    regenerateImages: {
      method: methods.POST,
      url: "/api/common/labels/regenerate/images"
    },
    getCustomPolicies: {
      method: methods.GET,
      url: "/api/common/custom/policies"
    },
    getCustomPoliciesAll: {
      method: methods.GET,
      url: "/api/common/custom/policies/all"
    },
    addCustomPolicies: {
      method: methods.POST,
      url: "/api/common/custom/policies"
    },
    editCustomPolicies: {
      method: methods.PUT,
      url: "/api/common/custom/policies"
    },
    deleteCustomPolicies: {
      method: methods.DELETE,
      url: "/api/common/custom/policies"
    },
    getAuditLogApiCount: {
      method: methods.GET,
      url: "/api/common/audit/apiusage/summary"
    },
    getUserAuditLog: {
      method: methods.GET,
      url: "/api/common/account/b2c/audit/logs"
    },
    getAimsManagerRegistredDevices: {
      method: methods.GET,
      url: "/api/aimsmanager/device/register"
    },
    RegistredAimsManagerDevice: {
      method: methods.POST,
      url: "/api/aimsmanager/device/register"
    },
    deleteAimsManagerDevice: {
      method: methods.DELETE,
      url: "/api/aimsmanager/device/register"
    },
    getInactiveUsers: {
      method: methods.GET,
      url: "/api/common/account/b2c/not/active"
    },
    /* Vision Camera EuroShow */
    getShelvesList: {
      method: methods.GET,
      url: "/api/common/visions/shelves"
    },
    getShelfDetails: {
      method: methods.GET,
      url: "/api/common/visions/shelf"
    },
    changeQr: {
      method: methods.POST,
      url: "/api/common/visions/changeqr"
    },
    getRogDetails: {
      method: methods.GET,
      url: "/api/common/visions/rog"
    },
    getComparepog: {
      method: methods.GET,
      url: "/api/common/visions/rog/comparepog"
    },
    // Camera IC Firmware API's
    getCameraICList: {
      method: methods.GET,
      url: "/api/common/otamanager/camera/cameraicota/otapackage"
    },
    saveUploadToGateway: {
      method: methods.POST,
      url: "/api/common/otamanager/camera/cameraicota/otapackage/uploadFirmware"
    },
    saveUploadedFile: {
      method: methods.POST,
      url: "/api/common/otamanager/camera/cameraicota/otapackage/file"
    },
    deleteCameraICFirmware: {
      method: methods.DELETE,
      url: "/api/common/otamanager/camera/cameraicota/otapackage/delete"
    },
    // Camera OTA
    getCameraOtaPackage: {
      method: methods.GET,
      url: "/api/common/otamanager/camera/cameraota/otapackage"
    },
    deleteCameraOtaPackage: {
      method: methods.DELETE,
      url: "/api/common/otamanager/camera/cameraota/otapackage/delete"
    },
    getCameraTotalTagStatus: {
      method: methods.GET,
      url: "/api/common/otamanager/camera/cameraota/status"
    },
    getCameraTagStatusList: {
      method: methods.GET,
      url: "/api/common/otamanager/camera/cameraota/status/taglist"
    },
    getCameraOtaEnable: {
      method: methods.GET,
      url: "/api/common/otamanager/camera/cameraota/otaschedule"
    },
    disableCameraOtaSchedule: {
      method: methods.DELETE,
      url: "/api/common/otamanager/camera/cameraota/otaschedule"
    },
    cameraOtaStatus: {
      method: methods.GET,
      url: "/api/common/otamanager/camera/cameraota/status/taglist/detail"
    },
    saveCameraOtaPackage: {
      method: methods.POST,
      url: "/api/common/otamanager/camera/cameraota/otapackage/file"
    },
    getCameraStoreLabels: {
      method: methods.GET,
      url: "/api/common/otamanager/camera/cameraota/otaschedule/details"
    },
    getCameraOtaScheduleInfo: {
      method: methods.GET,
      url: "/api/common/otamanager/camera/cameraota/otaschedule/scheduleinfo"
    },
    saveCameraOtaSetting: {
      method: methods.POST,
      url: "/api/common/otamanager/camera/cameraota/otaschedule"
    },
    /* label OTA */
    // OTA MANAGER
    saveOtaPackage: {
      method: methods.POST,
      url: "/api/common/otamanager/label/labelota/otapackage/file"
    },
    getOtaPackage: {
      method: methods.GET,
      url: "/api/common/otamanager/label/labelota/otapackage"
    },
    getTotalTagStatus: {
      method: methods.GET,
      url: "/api/common/otamanager/label/labelota/status"
    },
    getTagStatusList: {
      method: methods.GET,
      url: "/api/common/otamanager/label/labelota/status/taglist"
    },
    getOtaEnable: {
      method: methods.GET,
      url: "/api/common/otamanager/label/labelota/otaschedule"
    },
    disableOtaSchedule: {
      method: methods.DELETE,
      url: "/api/common/otamanager/label/labelota/otaschedule"
    },
    saveOtaSetting: {
      method: methods.POST,
      url: "/api/common/otamanager/label/labelota/otaschedule"
    },
    otaStatus: {
      method: methods.GET,
      url: "/api/common/otamanager/label/labelota/status/taglist/detail"
    },
    getLabelOtaScheduleStatus: {
      method: methods.GET,
      url: "/api/common/otamanager/label/labelota/otaschedule/checkstatus"
    },
    getStoreLabels: {
      method: methods.GET,
      url: "/api/common/otamanager/label/labelota/otaschedule/details"
    },
    getLabelOtaScheduleInfo: {
      method: methods.GET,
      url: "/api/common/otamanager/label/labelota/otaschedule/scheduleinfo"
    },
    deleteOtaPackage: {
      method: methods.DELETE,
      url: "/api/common/otamanager/label/labelota/otapackage/delete"
    },
    deleteGatewayEnroll: {
      method: methods.DELETE,
      url: "/api/common/gateway/dps/enrollment"
    },
    GetArticleInfoBySearchType: {
      method: methods.GET,
      url: "/api/common/articles/assign/search"
    },
    getHashKey: {
      method: methods.GET,
      url: "/api/common/lbs/get/hashkey"
    },
    generateQrCode: {
      method: methods.POST,
      url: "/api/common/company/generate/qrcode"
    },
    getGatewayOfflineStatus: {
      method: methods.GET,
      url: "/api/common/store/notice/gwoff"
    },
    postGatewayOfflineStatus: {
      method: methods.POST,
      url: "/api/common/store/notice/gwoff"
    },
    getVisionConfigStatus: {
      method: methods.GET,
      url: "/api/common/visions/store/status"
    },
    postVisionConfigStatus: {
      method: methods.POST,
      url: "/api/common/visions/store/status"
    },
    getLicenseConfigStatus: {
      method: methods.GET,
      url: "/api/common/store/license"
    },
    postLicenseConfigStatus: {
      method: methods.POST,
      url: "/api/common/store/license"
    },
    getSensorAlertExceptionStatus: {
      method: methods.GET,
      url: "/api/common/store/sensor/alert-exclusion/schedule"
    },
    postSensorAlertExceptionStatus: {
      method: methods.POST,
      url: "/api/common/store/sensor/alert-exclusion/schedule"
    },
    
    getLoadcellConfigStatus: {
      method: methods.GET,
      url: "/api/common/store/loadcell/auto-recalibration/status"
    },
    postLoadcellConfigStatus: {
      method: methods.POST,
      url: "/api/common/store/loadcell/auto-recalibration/status"
    },
    getMasterBoxConfigStatus: {
      method: methods.GET,
      url: "/api/common/store/masterbox/status"
    },
    postMasterBoxConfigStatus: {
      method: methods.POST,
      url: "/api/common/store/masterbox/status"
    },
    getLabelStore: {
      method: methods.GET,
      url: "/api/common/labels/store"
    },
    getSearchedGateway: {
      method: methods.GET,
      url: "/api/common/gateway/search"
    },
    // Get lables and images affected by template
    getLabelImageCount: {
      method: methods.GET,
      url: "/api/common/templates/labels/images/count"
    },

    /* VisionCamera */
    getShelfManager: {
      method: methods.GET,
      url: "/vision/api/common/visions"
    },
    getServerController: {
      method: methods.GET,
      url: "/api/common/visions/server/controller"
    },

    getConfiguration: {
      method: methods.GET,
      url: "/vision/api/common/visions/configuration"
    },
    postConfiguration: {
      method: methods.POST,
      url: "/vision/api/common/visions/configuration"
    },
    getCameraOverview: {
      method: methods.GET,
      url: "/vision/api/common/visions/overview"
    },
    getVisionCaptureStatus: {
      method: methods.GET,
      url: "/vision/api/common/visions/captureStatus"
    },
    getVisionCaptureHistory: {
      method: methods.GET,
      url: "/vision/api/common/visions/capturehistory"
    },
    getVisionCameraHistory: {
      method: methods.GET,
      url: "/vision/api/common/visions/camerahistory"
    },
    updateCameraRoi: {
      method: methods.PUT,
      url: "/vision/api/common/visions/camera/roi"
    },

    getShelfGroup: {
      method: methods.GET,
      url: "/vision/api/common/visions/shelfgroup"
    },

    // Load cell api's    
    getLoadCellList: {
      method: methods.GET,
      url: "/sensor/api/v1/loadcell"
    },
    addLoadCellDetails: {
      method: methods.POST,
      url: "/sensor/api/v1/loadcell"
    },
    updateLoadCellDetails: {
      method: methods.PUT,
      url: "/sensor/api/v1/loadcell"
    },
    removeLoadCell: {
      method: methods.DELETE,
      url: "/sensor/api/v1/loadcell"
    },
    saveInstantCheck: {
      method: methods.PUT,
      url: "/sensor/api/v1/loadcell/instant-check"
    },
    getLoadCellShelfInfo: {
      method: methods.GET,
      url: "/sensor/api/v1/loadcell/shelf"
    },

    // Shelf Tasks page api's
    shelfTaskIssueClose: {
      method: methods.POST,
      url: "/vision/api/common/visions/operation/issue/close"
    },

    getShelfTasksList: {
      method: methods.GET,
      url: "/vision/api/common/visions/operation/issue"
    },

    getvisionErrorFilters: {
      method: methods.GET,
      url: "/vision/api/common/visions/shelves/linked/department/detail"
    },
    getVisionSummary: {
      method: methods.GET,
      url: "/vision/api/common/visions/summary"
    },
    getVisionSummaryHistory: {
      method: methods.GET,
      url: "/vision/api/common/visions/summary/history"
    },
    getVisionsErrorList: {
      method: methods.GET,
      url: "/api/common/visions/operation"
    },
    getErrorDetails: {
      method: methods.GET,
      url: "/vision/api/common/visions/operation/history/detail"
    },
    getShelfGroupList: {
      method: methods.GET,
      url: "/api/common/visions/shelfgroup"
    },
    getShelfGroupDetails: {
      method: methods.GET,
      url: "/vision/api/common/visions/shelves"
    },
    getVisionsSchedule: {
      method: methods.GET,
      url: "/vision/api/common/visions/schedule"
    },
    getVisionsRepeatSchedule: {
      method: methods.GET,
      url: "/vision/api/common/visions/repeatschedule"
    },
    cameraTakeSnapshot: {
      method: methods.POST,
      url: "/vision/api/common/visions/force/snapshot"
    },
    getPlanogramDetails: {
      method: methods.GET,
      url: "/vision/api/common/visions/planogram/info"
    },

    getlinkedShelfList: {
      method: methods.GET,
      url: "/vision/api/common/visions/operation/shelves/linked"
    },

    getRogHistoryDetail: {
      method: methods.GET,
      url: "/vision/api/common/visions/rog/history/detail"
    },
    postVisionsscheduleStore: {
      method: methods.POST,
      url: "/vision/api/common/visions/schedule/store"
    },
    getVisionsscheduleStore: {
      method: methods.GET,
      url: "/vision/api/common/visions/schedule/store"
    },
    deleteVisionsscheduleStore: {
      method: methods.DELETE,
      url: "/vision/api/common/visions/schedule/store"
    },
    postVisionsRepeatScheduleStore: {
      method: methods.POST,
      url: "/vision/api/common/visions/repeatschedule/store"
    },
    getVisionsRepeatScheduleStore: {
      method: methods.GET,
      url: "/vision/api/common/visions/repeatschedule/store"
    },

    getlinkedshelfData: {
      method: methods.GET,
      url: "/vision/api/common/visions/shelf/detail"
    },
    getVisionPlanogramUploadHistory: {
      method: methods.GET,
      url: "/vision/api/common/visions/planogram/history"
    },
    downloadVisionPlanogramUploadHistory: {
      method: methods.GET,
      url: "/vision/api/common/visions/planogram/file/download"
    },
    getVisionPlanogramUploadHistoryDetail: {
      method: methods.GET,
      url: "/vision/api/common/visions/planogram/history/detail"
    },
    getVisionPlanogramUploadHistoryErrorLogs: {
      method: methods.GET,
      url: "/vision/api/common/visions/planogram/validationerror/logs"
    },
    uploadVisionsPlanogram: {
      method: methods.POST,
      url: "/vision/api/common/visions/planogram/upload/multipart"
    },
    callPageChange: {
      method: methods.POST,
      url: "/vision/api/common/visions/schedule/store/tempSchedule"
    },
    /** Webhook */
    getWebhookSubscriptionList: {
      method: methods.GET,
      url: "/api/common/webhook"
    },
    postWebhookSubscription: {
      method: methods.POST,
      url: "/api/common/webhook"
    },
    deleteWebhookSubscription: {
      method: methods.DELETE,
      url: "/api/common/webhook"
    },
    /* Robot Config */
    getRobotCommonConfigList: {
      method: methods.GET,
      url: "/robot/api/common/robot/store/configAll"
    },
    postRobotCommonConfig: {
      method: methods.POST,
      url: "/robot/api/common/robot/store/config"
    },
    deleteRobotCommonConfig: {
      method: methods.DELETE,
      url: "/robot/api/common/robot/store/config"
    },
    /* Camera Vision Robot */
    getRobotList: {
      method: methods.GET,
      url: "/robot/api/common/robot/list"
    },
    deleteRobot: {
      method: methods.POST,
      url: "/robot/api/common/robot/unregister"
    },
    robotConnectionHistory: {
      method: methods.GET,
      url: "/robot/api/common/robot/history/connection"
    },
    robotMissionHistory: {
      method: methods.GET,
      url: "/robot/api/common/robot/history/mission"
    },
    robotFloorList: {
      method: methods.GET,
      url: "/robot/api/common/robot/floorMapList"
    },
    robotFloorMap: {
      method: methods.GET,
      url: "/robot/api/common/robot/floorMap"
    },
    robotShelfLocationMapping: {
      method: methods.POST,
      url: "/robot/api/common/robot/shelfLocationMapping"
    },
    robotPostLocationGroup: {
      method: methods.POST,
      url: "/robot/api/common/robot/locationGroup"
    },
    getRobotShelfLocationMapping: {
      method: methods.GET,
      url: "/robot/api/common/robot/shelfLocationMapping"
    },
    /** Toast Pos */
    getToastPosStoreMapping: {
      method: methods.GET,
      url: "/api/common/toastpos/store/mapping"
    },
    getToastPosIntegrationStatus: {
      method: methods.GET,
      url: "/api/common/toastpos/integration/status"
    },
    postTToastPosStoreMapping: {
      method: methods.POST,
      url: "/api/common/toastpos/store/mapping"
    },
    deleteToastPosCustomer: {
      method: methods.DELETE,
      url: "/api/common/toastpos/customer"
    },
    postToastPosCustomer: {
      method: methods.POST,
      url: "/api/common/toastpos/customer"
    },
    toastPosFullFlesh: {
      method: methods.POST,
      url: "/api/common/toastpos/catalog/full/flesh"
    },
    getToastPosAuditLogs: {
      method: methods.GET,
      url: "/api/common/toastpos/audit/log"
    },
    updateTemplateTypeColor: {
      method: methods.POST,
      url: "/api/common/templates/color/apply"
    },
    exactLabelPreview: {
      method: methods.GET,
      url: "/api/common/labels/preview/exact"
    },
    forceUpdateWhiteList: {
      method: methods.PUT,
      url: "/api/common/whitelist/update/gateway"
    },
    /** Meeting Solution */
    getMeetingSolutionIntegrationStatus: {
      method: methods.GET,
      url: "/uts/api/v1/integration/status"
    },
    getMeetingSolutionCallback: {
      method: methods.GET,
      url: "/uts/api/v1/callback"
    },
    updateMeetingSolutionIntegrationStatus: {
      method: methods.POST,
      url: "/uts/api/v1/integration/status"
    },
    getMeetingSolutionRoomList: {
      method: methods.GET,
      url: "/uts/rooms"
    },
    getMeetingSolutionFullFlush: {
      method: methods.GET,
      url: "/uts/api/v1/fullflush"
    },
    deleteMeetingSolutionIntegration: {
      method: methods.DELETE,
      url: "/uts/api/v1/integration/status"
    },
    getMeetingSolutionIntegrationEvents: {
      method: methods.GET,
      url: "/uts/api/v1/events"
    },
    getMeetingSolutionRoomMappingEvents: {
      method: methods.GET,
      url: "/uts/api/v1/room/mapping/events"
    },
    getStoreWiseRoomMapping: {
      method: methods.GET,
      url: "/uts/api/v1/room/mapping"
    },
    getSearchRoomMapping: {
      method: methods.GET,
      url: "/uts/api/v1/events/search"
    },
    updateStoreWiseRoomMapping: {
      method: methods.POST,
      url: "/uts/api/v1/room/mapping"
    },
    // ALL Power Rail API's
    // Get power rail list
    getPowerRail: {
      method: methods.GET,
      url: "/api/common/power/rail"
    },
    // Delete / un-link power rail / Assign power rail
    deletePowerRail: {
      method: methods.DELETE,
      url: "/api/common/power/rail"
    },
    postAssignedPowerRail: {
      method: methods.POST,
      url: "/api/common/power/rail/assign"
    },
    putAssignedPowerRail: {
      method: methods.PUT,
      url: "/api/common/power/rail"
    },
    resetPowerRail: {
      method: methods.PUT,
      url: "/api/common/power/rail/labels/reset"
    },
    unLinkPowerRail: {
      method: methods.DELETE,
      url: "/api/common/power/rail/unlink"
    },
    // Get assign and un-assign labels
    getPowerRailLabelCount: {
      method: methods.GET,
      url: "/api/common/power/rail/labels"
    },
    // Power Rail OTA Status
    getPowerRailOtaStatus: {
      method: methods.GET,
      url: "/api/common/power/rail/ota/status"
    },
    // Power Rail OTA Start/Stop
    postPowerRailOta: {
      method: methods.POST,
      url: "/api/common/power/rail/ota"
    },
    getPowerRailOtaLog: {
      method: methods.GET,
      url:'/api/common/power/rail/ota/logs'
    },

    /* onDemand alive */
    forceSignalAlive: {
      method: methods.PUT,
      url: "/api/common/labels/force/alive/signal/ondemand"
    },
    // Solum LCD API's
    getLcdListData: {
      method: methods.GET,
      url: "/cms/api/v1/common/lcd"
    },
    deleteLCD: {
      method: methods.DELETE,
      url: "/cms/api/v1/common/lcd/dps/enrollment"
    },
    getProductMediaList: {
      method: methods.GET,
      url: "/cms/api/v1/lcd/product/link"
    },
    getMediaCountList: {
      method: methods.GET,
      url: "/cms/api/v1/lcd/media/link"
    },
    getMediaFile: {
      method: methods.GET,
      url: "/cms/api/v1/media/download"
    },
    assignLCD: {
      method: methods.POST,
      url: "/cms/api/v1/labels/assign"
    },
    unAssignLCD: {
      method: methods.POST,
      url: "/cms/api/v1/labels/unassign"
    },
    getMediaList: {
      method: methods.GET,
      url: "/cms/api/v1/media"
    },
    addNewMedia: {
      method: methods.POST,
      url: "/cms/api/v1/media"
    },
    registerLcd: {
      method: methods.POST,
      url: "/cms/api/v1/common/lcd/dps/enrollment"
    },
    // TEMPLATE API'S
    getLcdTemplates: {
      method: methods.GET,
      url: "/cms/api/v1/templates"
    },
    deleteLcdTemplates: {
      method: methods.DELETE,
      url: "/cms/api/v1/templates"
    },
    lcdAddTemplate: {
      method: methods.POST,
      url: "/cms/api/v1/templates"
    },
    lcdEditTemplate: {
      method: methods.PUT,
      url: "/cms/api/v1/templates"
    },
    // Tewmplate LCD Preview API's
    getPreviewLcdList: {
      method: methods.POST,
      url: "/cms/api/v1/template/preview"
    },

    deleteMedia: {
      method: methods.DELETE,
      url: "/cms/api/v1/media"
    },
    getLinkedLCDList: {
      method: methods.GET,
      url: "/cms/api/v1/media/link"
    },
    linkLCDMedia: {
      method: methods.POST,
      url: "/cms/api/v1/media/link"
    },
    unlinkLCDMedia: {
      method: methods.DELETE,
      url: "/cms/api/v1/media/link"
    },
    getVisionStatus: {
      method: methods.GET,
      url: "/api/common/visions/store/status"
    },

    // Delete repeat Schedule
    deleteRepeatSchedule: {
      method: methods.DELETE,
      url: "/vision/api/common/visions/repeatschedule/store" // DELETE /api/v2/common/visions/
    },

    // unassinged Camera Label
    unAssignedCameraLabel: {
      method: methods.POST,
      url: "/vision/api/common/visions/unlink"
    },
    // assigned Camera Label (register / link device)
    assignedCameraLabel: {
      method: methods.POST,
      url: "/vision/api/common/visions/link"
    },

    saveUserActionData: {
      method: methods.POST,
      url: "/vision/api/common/visions/rog/useraction"
    },
    getEslInfoMapping: {
      method: methods.GET,
      url: "/vision/api/common/visions/eslinfomapping"
    },
    // Vision Camera AutoAssign
    saveAutoAssignInfo: {
      method: methods.POST,
      url: "/vision/api/common/visions/operation/useraction"
    },

    tokenRefresh: {
      method: methods.POST,
      url: "/api/common/token/refresh"
    },
    dashboardLogin: {
      method: methods.POST,
      url: "/api/common/login"
    },
    // Webhooks
    getWebhooksLogs: {
      method: methods.GET,
      url: "/api/common/webhook/logs"
    },
    getGatewayStatusLogs: {
      method: methods.GET,
      url: "/api/common/webhook/gateway/status/logs"
    },
    getWebhookHistory: {
      method: methods.GET,
      url: "/uts/api/v1/webhook/history"
    },
    // Button Configuration
    getButtonConfigrationList: {
      method: methods.GET,
      url: "/api/common/functions/labels/button/config"
    },

    // edit the existing button configuration.
    editButtonConfigrationList: {
      method: methods.PUT,
      url: "/api/common/functions/labels/button/config"
    },

    // add new button configuration
    addButtonConfigration: {
      method: methods.POST,
      url: "/api/common/functions/labels/button/config"
    },
    // delete button Configuration
    deleteButtonConfig: {
      method: methods.DELETE,
      url: "/api/common/functions/labels/button/config"
    },
    // Shelf Label
    getShelfInfo: {
      method: methods.GET,
      url: "/api/common/labels/shelfs"
    },
    getShelfInfoDetails: {
      method: methods.GET,
      url: "/api/common/labels/shelfs/detail"
    },
    // Batch Info API's
    getBatchInfo: {
      method: methods.GET,
      url: "/api/common/labels/all/batches"
    },
    getBatchInfoDetails: {
      method: methods.GET,
      url: "/api/common/labels/batch/details"
    },
    getBatchInfoDetails: {
      method: methods.GET,
      url: "/api/common/labels/batch/details"
    },
    getLabelStatus: {
      method: methods.GET,
      url: "/api/common/labels/status"
    },
    // Sensors API
    getSensorSummary: {
      method: methods.GET,
      url: "/sensor/api/v1/sensor/summary"
    },
    getSensorSummaryList: {
      method: methods.GET,
      url: "/sensor/api/v1/sensor"
    },
    getActiveAlerts: {
      method: methods.GET,
      url: "/sensor/api/v1/sensor/alerts/summary"
    },
    getHistoryAlerts: {
      method: methods.GET,
      url: "/sensor/api/v1/sensor/alerts/history/summary"
    },
    saveSensorDetails: {
      method: methods.PUT,
      url: "/sensor/api/v1/sensor"
    },
    addSensorDetails: {
      method: methods.POST,
      url: "/sensor/api/v1/sensor"
    },

    // Sensor Alert list and Settings API's
    getAlertList: {
      method: methods.GET,
      url: "/sensor/api/v1/sensor/alerts"
    },
    getAlertSettingList: {
      method: methods.GET,
      url: "/sensor/api/v1/sensor/noti/devices"
    },
    saveAlertSettingList: {
      method: methods.PUT,
      url: "/sensor/api/v1/sensor/noti/devices"
    },
    deleteAlertSettingList: {
      method: methods.DELETE,
      url: "/sensor/api/v1/sensor/noti/devices"
    },
    getNotiHistoryDetails: {
      method: methods.GET,
      url: "/sensor/api/v1/sensor/noti/history"
    },
    getSensorDetails: {
      method: methods.GET,
      url: "/sensor/api/v1/sensor/logs"
    },
    getSensorDetailsAggregate: {
      method: methods.GET,
      url: "/sensor/api/v1/sensor/logs/aggregate"
    },
    exportSensorLogs: {
      method: methods.GET,
      url: "/sensor/api/v1/sensor/logs/export"
    },
    getAlertHistory: {
      method: methods.GET,
      url: "/sensor/api/v1/sensor/alerts"
    },
    deleteSensor: {
      method: methods.DELETE,
      url: "/sensor/api/v1/sensor"
    },
    // robot
    getLocationGroup: {
      method: methods.GET,
      url: "/robot/api/v2/robot/locationGroup"
    },

    getScheduleRogList: {
      method: methods.GET,
      url: "/robot/api/v2/robot/rog"
    },
    saveScheduleRogList: {
      method: methods.POST,
      url: "/robot/api/v2/robot/rog"
    },

    saveSvgImage: {
      method: methods.POST,
      url: "/robot/api/v2/robot/svgMap"
    },
    getSvgImage: {
      method: methods.GET,
      url: "/robot/api/v2/robot/svgMap"
    },
    getSvgList: {
      method: methods.GET,
      url: "/robot/api/v2/robot/svgList"
    },
    getLocationMetaData: {
      method: methods.GET,
      url: "/robot/api/v2/robot/loadLocationMeta"
    },

    saveFloorMap: {
      method: methods.POST,
      url: "/robot/api/v2/robot/floorMap"
    },
    addRobot: {
      method: methods.POST,
      url: "/robot/api/v2/robot/register"
    },
    attachRobot: {
      method: methods.POST,
      url: "/robot/api/v2/robot/attach"
    },

    saveRobotRepeatSchedule: {
      method: methods.POST,
      url: "/robot/api/v2/robot/schedule"
    },
    getRobotRepeatSchedule: {
      method: methods.GET,
      url: "/robot/api/v2/robot/schedule"
    },
    deleteRobotRepeatSchedule: {
      method: methods.POST,
      url: "/robot/api/v2/robot/scheduleDelete"
    },
    getPlanogramCompHistoryDetail: {
      method: methods.GET,
      url: "/vision/api/common/visions/planogram/compliance/history/detail"
    },
    // Contact Info
    getContactInfoSuperAdmin: {
      method: methods.GET,
      url: "/api/common/company/contact/info"
    },
    saveContactInfoSuperAdmin: {
      method: methods.PUT,
      url: "/api/common/company/contact/info"
    },
    // GET API Token
    accessToken: {
      method: methods.GET,
      url: "/api/common/atensystemsmap/access/token"
    },
    // GET API FOR SETTING SENSOR'S UNIT
    getSensorUnit: {
      method: methods.GET,
      url: "/api/common/config/sensor/unit"
    },

    // SET SENSOR'S UNIT FROM THE SENSOR'S PAGE
    setSensorUnit: {
      method: methods.PUT,
      url: "/api/common/config/sensor/unit"
    },
    // Master Box API's
    getMasterBoxList: {
      method: methods.GET,
      url: "/masterbox/api/v1/info"
    },
    registerMasterBox: {
      method: methods.POST,
      url: "/masterbox/api/v1/dps/register"
    },
    deRegisterMasterBox: {
      method: methods.POST,
      url: "/masterbox/api/v1/dps/deregister"
    },
    updateMasterBox: {
      method: methods.PUT,
      url: "/masterbox/api/v1/update"
    },
    // Wifi Config
    getWifiConfig: {
      method: methods.GET,
      url: "/api/common/store/wifi/configuration"
    },
    saveWifiConfig: {
      method: methods.POST,
      url: "/api/common/store/wifi/configuration"
    },
    deleteWifiConfig: {
      method: methods.DELETE,
      url: "/api/common/store/wifi/configuration"
    },
    updateWifiConfig: {
      method: methods.PUT,
      url: "/api/common/store/wifi/configuration"
    },
    decryptPassword: {
      method: methods.POST,
      url: "/api/common/decrypt"
    },
    getAssingedUnassignedList: {
      method: methods.GET,
      url: "/api/common/store/labels/count"
    },
    // One Button Reset — labels linked to another store
    getLinkedOtherStoreLabels: {
      method: methods.GET,
      url: "/api/common/labels/unassign/linked/other/store"
    },
    postLinkedOtherStoreUnassign: {
      method: methods.POST,
      url: "/api/common/labels/unassign/linked/other/store"
    },
    // Store Flip API
    postStoreFlipConfirmation: {
      method: methods.POST,
      url: "/api/common/store/gw/labels/clear"
    },
    setReportConfigForSIP: {
      method: methods.PUT,
      url: "/api/common/account/report/config"
    },
    checklbspermission: {
      method: methods.GET,
      url: "/api/common/otamanager/check/permission"
    },

    getPowerRailcontroller: {
      method: methods.GET,
      url: "/api/common/power/rail/ble"
    },
    // Cisco meraki apis
    getCiskoMerakiDeviceNetwork: {
      method: methods.GET,
      url: "/ciscomeraki/api/v1/cisco/meraki/devices/network/all"
    },

    // remove from cisco meraki device network
    removeFromCiscoMerakiDeviceNetwork: {
      method: methods.POST,
      url: "/ciscomeraki/api/v1/cisco/meraki/devices/network/remove"
    },

    // register to cisco meraki device network
    registerToCiscoMerakiDeviceNetwork: {
      method: methods.POST,
      url: "/ciscomeraki/api/v1/cisco/meraki/devices/network/claim"
    },

    // save shelf configuratoin
    saveDefaultsShelfConfiguration: {
      method: methods.PUT,
      url: "/api/common/visions/store/default/shelfconfig"
    },

    // javascript snippets
    // GET API
    getJsSnippet: {
      method: methods.GET,
      url: "/api/common/config/js/code/snippets"
    },
    addJsSnippets: {
      method: methods.POST,
      url: "/api/common/config/js/code/snippets"
    },
    editJsSnippets: {
      method: methods.PUT,
      url: "/api/common/config/js/code/snippets"
    },
    deleteJsSnippet: {
      method: methods.DELETE,
      url: "/api/common/config/js/code/snippets"
    },

    // shelfwise shelf config (vision)
    getShelfwiseShelfConfig: {
      method: methods.GET,
      url: "/vision/api/common/visions/shelfconfig"
    },
    deleteShelfConfig: {
      method: methods.DELETE,
      url: "/vision/api/common/visions/shelfconfig"
    },
    saveShelfwiseShelfConfig: {
      method: methods.POST,
      url: "/vision/api/common/visions/shelfconfig"
    },
    //
    getArticleList: {
      method: methods.GET,
      url: "/api/common/config/article/info"
    },

    setArticlePreview: {
      method: methods.POST,
      url: "/api/common/preview/template/articles"
    },

    getButtonLabelConfigStatus: {
      method: methods.GET,
      url: "/api/common/functions/labels/button/config/status"
    },
    // Matrix Usage API's
    getMatrixSummary: {
      method: methods.GET,
      url: "/metricsbe/api/v1/customer/summary"
    },
    getProdductHistroy: {
      method: methods.GET,
      url: "/metricsbe/api/v1/customer/product-update/history"
    },
    getAssignHistroy: {
      method: methods.GET,
      url: "/metricsbe/api/v1/customer/assign/history"
    },
    getImageGeneratorHistory: {
      method: methods.GET,
      url: "/metricsbe/api/v1/customer/image-generated/history"
    },
    getLEDHistory: {
      method: methods.GET,
      url: "/metricsbe/api/v1/customer/led-request/history"
    },
    ditherImage: {
      method: methods.PUT,
      url: "/api/common/labels/image/dither/preview"
    },
    getTermAndCondition: {
      method: methods.GET,
      url: "/api/common/account/tnc"
    },
    updateTermAndCondition: {
      method: methods.PUT,
      url: '/api/common/account/tnc'
    },
    getScannerList: {
      method: methods.GET,
      url : "/rfidbe/api/v1/rfid/devices"
    },
    updateScannerList: {
      method: methods.PUT,
     url : "/rfidbe/api/v1/rfid/devices"
    },
    getScanResult: {
      method: methods.GET,
      url : "/rfidbe/api/v1/rfid/results"
    },
    getScannerConfigStatus: {
      method: methods.GET,
      url: "/rfidbe/api/v1/rfid/configuration"
    },
    updateScannerConfigStatus: {
      method: methods.PUT,
      url: "/rfidbe/api/v1/rfid/configuration"
    },
    createSchedulerList: {
      method: methods.POST,
      url: "/rfidbe/api/v1/rfid/schedules"
    },
    unAssignRFIDReader: {
      method: methods.DELETE,
      url : "/rfidbe/api/v1/rfid/devices"
    },
    saveFastMode: {
      method: methods.POST,
      url: "/rfidbe/api/v1/rfid/scan"
    },

    getRepeatScheduleList: {
      method: methods.GET,
      url: "/rfidbe/api/v1/rfid/schedules"
    },
    getFastModeList: {
      method: methods.GET,
      url: "/rfidbe/api/v1/rfid/scan"
    },
    getRackResult: {
      method:methods.GET,
      url: '/rfidbe/api/v1/rfid/results/rackdetails'
    },
    getUpcDetils: {
      method: methods.GET,
      url:'/rfidbe/api/v1/rfid/results/upcdetails'
    },
    getRfidDeviceDetails: {
      method: methods.GET,
      url: '/rfidbe/api/v1/rfid/devices/details'
    },
    updateRfidDeviceDetails: {
      method :methods.PUT,
      url : '/rfidbe/api/v1/rfid/devices/details'
    },
    deleteRfidSchdule: {
      method:methods.DELETE,
      url: '/rfidbe/api/v1/rfid/schedules'
    },
    getDailyRepeatSchedule : {
      method: methods.GET,
      url: '/rfidbe/api/v1/rfid/scan/temp/repeat/schedule'
    },
    saveDailyRepeatSchedule : {
      method: methods.PUT,
      url: '/rfidbe/api/v1/rfid/scan/temp/repeat/schedule'
    },
     getRfidUnassignedList : {
      method: methods.GET,
      url: '/rfidbe/api/v1/rfid/devices/unassigned'
    },


    //sftp
    //  https://stage00.common.solumesl.com/sftp/api/v2/common/config/sftp-config
    getSftpConfig: {
      method: methods.GET,
      url: "/api/common/sftp/config"
    },
    addSftpConfig: {
      method: methods.POST,
      url: "/api/common/sftp/config"
    },
    deleteSftpConfig: {
      method: methods.DELETE,
      url: "/api/common/sftp/config"
    },
    downloadSshKey: {
      method: methods.GET,
      url: "/api/common/sftp/download"
    },
    // getSftpLogList: {
    //   method: methods.GET,
    //   url: "/api/v2/common/logs/list"
    // },
    // downloadLogList: {
    //   method: methods.GET,
    //   url: "/api/v2/common/logs/download"
    // },
//dps
addGatewayDps:{
  method: methods.POST,
  url: "/api/common/gateway/dps/enrollment"
},
getGatewayDps:{
  method: methods.GET,
  url: "/api/common/gateway/dps/enrollment"
},
deleteGatewayDps:{
  method: methods.DELETE,
  url: "/api/common/gateway/dps/enrollment"
},
    // eps call
    enableEPSApi : {
       method: methods.POST,
      url: "/eps/api/v1/init"
    },
  disableEPSApi : {
       method: methods.POST,
      url: "/eps/api/v1/init"
    },

    //repeat schedule delete
    deleteRepeatScheduleForLabel: {
      method :methods.DELETE,
      url: '/api/common/labels/repeatschedule'
    },
    //repeat schedule for label
    addRepeatScheduleForlabel: {
      method: methods.POST,
      url: '/api/common/labels/repeatschedule'
    },
     //repeat schedule for product
    addRepeatScheduleForProduct: {
      method: methods.POST,
      url: '/api/common/labels/repeatschedule/article'
    },
    
    //repeat schedule for label
    getRepeatScheduleForlabel: {
      method: methods.GET,
      url: '/api/common/labels/repeatschedule'
    },
    getScheduleByStore: {
      method: methods.GET,
      url: '/storesc/api/v1/schedules'
    },
    getScheduleRecurrences: {
      method: methods.POST,
      url: '/storesc/api/v1/schedule/preview-recurrences'
    },
    getScheduleStatus: {
      method: methods.GET,
      url: '/storesc/api/v1/schedule/status'
    },
    saveScheduleByStore: {
      method: methods.POST,
      url: '/storesc/api/v1/schedule'
    },
    deleteScheduleById: {
      method: methods.DELETE,
      url: '/storesc/api/v1/schedule'
    },
    updateScheduleByStore: {
      method: methods.PUT,
      url: '/storesc/api/v1/schedule'
    },
    getScheduleStoreDetail: {
      method: methods.GET,
      url: '/storesc/api/v1/schedule/details'
    },
    setScheduleActive: {
      method: methods.POST,
      url: '/storesc/api/v1/schedule/toggle-active'
    },
    getLedInfo: {
      method: methods.GET,
      url:'/api/common/labels/led/info'
    },
    getPowerRailSummary: {
      method: methods.GET,
      url:'/api/common/power/rail/overview'
    },
    getCsrfToken: {
      method: methods.GET,
      url: '/common/api/v2/token/csrf'
    },
    getBannerNotices: {
      method: methods.GET,
      url: '/uts/api/v2/banners'
    },
    getServiceAccounts: {
      method: methods.GET,
      url: '/common/uts/api/v1/svcaccount'
    },
    getServiceAccountSecrets: {
      method: methods.GET,
      url: '/common/uts/api/v1/svcaccount/secret'
    },
    retrieveServiceAccountSecret: {
      method: methods.GET,
      url: '/common/uts/api/v1/svcaccount/secret/retrieve'
    },
    rotateServiceAccountSecret: {
      method: methods.POST,
      url: '/common/uts/api/v1/svcaccount/secret/rotate'
    },
    revokeServiceAccount: {
      method: methods.POST,
      url: '/common/uts/api/v1/svcaccount/revoke'
    },
    getServiceAccountPermissions: {
      method: methods.GET,
      url: '/common/uts/api/v1/svcaccount/resource/permission'
    },
    updateServiceAccountPermissions: {
      method: methods.POST,
      url: '/common/uts/api/v1/svcaccount/resource/permission'
    },
    updateServiceAccountCustomerMapping: {
      method: methods.PUT,
      url: '/common/uts/api/v1/svcaccount/customer/mapping'
    },
    getHalowGatewycountryPackage: {
      method: methods.GET,
      url: 'api/common/gateway/halow/country/packages'
    },
    getHalowGatewayChannels: {
      method: methods.GET,
      url: '/api/common/gateway/halow/channels'
    },

    // MFA (Multi Factor Authentication)

    getMemberMFAStatus:{
      method: methods.GET,
    url: '/api/common/account/b2c/groups/members/mfa/status' // api/common/account/b2c/groups/members/mfa/status
    },

    changeMFAforUser : {
      method: methods.PUT,
      url : '/api/common/account/b2c/groups/members'
    },
    removeMFAForUser : {
      method: methods.DELETE,
      url: '/api/common/account/b2c/groups/members'
    }

  },
  // Dicamo Privew URL
  // media: {
  //   thumbnail: 'http://edgydevice.com:5001/assets/thumbnail/'
  //   preview: 'http://edgydevice.com:5001/assets/SolumMedia/'
  // },
  errors: {
    templateNotFound: {
      code: "404",
      status: 404,
      msg: "It can't find template with the value"
    },
    labelNotWhitelisted: {
      code: null,
      status: null,
      msg: "label is not in the whiteList"
    },
    scheduleNotFound: {
      msg: "Schedule information not found."
    },
    passwordExpired: {
      msg: "Your password was expired."
    }
  },
  lbsSetting: {
    LBS_ENABLED_DEFAULT_SETTING: {
      enable: true,
      startTime: 1200,
      endTime: 16,
      gatheringEndTime: 1800,
      txPower: 2,
      txInterval: 30,
      threshold: 75
    },
    LBS_DISABLED_DEFAULT_SETTING: {
      enable: false
    }
  },
  LOCALHOST: "localhost",
  ROW_CLASS: "row-class",
  statusCode: {
    CONNCTED: Symbol.for("CONNCTED"),
    DISCONNCTED: Symbol.for("DISCONNCTED")
  },
  networkStatusColor: new Map([
    ["CONNECTED", "bg-stable"],
    ["NOT_READY", "bg-caution"],
    ["DISCONNECTED", "bg-danger"]
  ]),
  lbsSearchType: {
    getByStore: "getByStore",
    getByLabelId: "getByLabel",
    getByPosition: "getByPosition",
    getByArticleId: "getByArticleId",
    getByArticleName: "getByArticleName"
  },
  whitelistFetchType: {
    none: "NONE",
    add: "ADD",
    delete: "DELETE"
  },
  assignType: {
    assign: "Assign",
    unassign: "Unassign"
  },
  ACTIVE_PAGE: "activePage",
  labelStatus: {
    PROCESSING: "PROCESSING",
    SUCCESS: "SUCCESS",
    TIMEOUT: "TIMEOUT",
    UNASSIGNED: "UNASSIGNED",
    UNASSIGNING: "UNASSIGNING"
  },
  EXPORT_SIZE: 1000000000,
  TEMP: "TEMP",
  // Fixed LED blink durations (in seconds) — shared between LED config page and Blink LED dialog
  FIXED_LED_DURATIONS: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 300, 600, 900, 1200, 1500, 1800, 2100, 2400, 2700, 3000, 3300, 3600, 3900, 4200, 4500, 4800]
};

export default codes;
